module.exports = __webpack_public_path__ + "img/truck-trailer.2aa7b560.jpg";